import React, { useContext } from 'react';
import 'twin.macro';
import { AppContext, didomiEnabled, UserContext } from '../context';
import { TextLine } from '../text';
import { DividerTitle } from '../divider';
import { Icon } from '../icon';
import { SocialLinks } from '../social';
import { ArrowIcon } from 'icons';
import { MenuNavLink, menuStyle, opacityStyle } from '../linktypes';
import {
  ContactMenu,
  GoToDateMenu,
  MenuContent,
  MenuHeader,
  PrivacyMenu,
  SettingsMenu,
  UploadMenu,
} from './';
import { SearchForm } from '../form';
import { mainNavList } from '../../data/';

export const OpenMenuActionButton = ({ label, MenuToLoad, ...restProps }) => {
  return (
    <div css={menuStyle} tw='!flex w-full justify-between' {...restProps}>
      <TextLine text={label} css={[opacityStyle]} />
      <Icon Type={ArrowIcon} rotation='90' />
    </div>
  );
};

export const OpenSettingsMenu = (props) => <OpenMenuActionButton {...props} />;
export const OpenUploadMenu = (props) => <OpenMenuActionButton {...props} />;
export const OpenContactMenu = (props) => <OpenMenuActionButton {...props} />;
export const OpenGoToDateMenu = (props) => <OpenMenuActionButton {...props} />;
export const OpenPrivacyMenu = (props) => <OpenMenuActionButton {...props} />;

export const MainMenu = ({ modalId }) => {
  const { user } = useContext(UserContext);
  const { setSlideIn, windowSize } = useContext(AppContext);

  return (
    <>
      <MenuHeader title='menu' modalId={modalId} noBackButton />
      <MenuContent>
        {!['DESKTOP'].includes(windowSize.adBreakPoint) && (
          <>
            <DividerTitle title='Zoeken' />
            <div tw='block mb-2'>
              <SearchForm />
            </div>
            <DividerTitle title='Top navigatie' />
            {mainNavList(user).map((navItem) => (
              <MenuNavLink key={navItem.label} label={navItem.label} to={navItem.pathname} />
            ))}
          </>
        )}
        <DividerTitle title='Navigatie' />
        <OpenSettingsMenu
          label='Instellingen'
          onClick={() =>
            setSlideIn({
              active: true,
              fullwidth: false,
              Component: SettingsMenu,
            })
          }
        />
        <OpenUploadMenu
          label='Uploaden of linktippen'
          onClick={() =>
            setSlideIn({
              active: true,
              fullwidth: false,
              Component: UploadMenu,
            })
          }
        />
        <OpenGoToDateMenu
          label='Ga naar datum'
          onClick={() =>
            setSlideIn({
              active: true,
              fullwidth: false,
              Component: GoToDateMenu,
            })
          }
        />
        <OpenContactMenu
          label='Contact'
          onClick={() =>
            setSlideIn({
              active: true,
              fullwidth: false,
              Component: ContactMenu,
            })
          }
        />
        <OpenPrivacyMenu
          label='Privacy & info'
          onClick={() =>
            setSlideIn({
              active: true,
              fullwidth: false,
              Component: PrivacyMenu,
            })
          }
        />

        <div css={[menuStyle, opacityStyle]}>
          <a
            href='https://api-live.dumpert.nl/mobile_api/json/rss'
            target='_blank'
            rel='noreferrer'
          >
            <TextLine text='RSS' />
          </a>
        </div>
        {didomiEnabled && (
          <div css={[menuStyle, opacityStyle]} onClick={() => window.Didomi.preferences.show()}>
            Privacy instellingen
          </div>
        )}
        <DividerTitle title='Volg ons op' tw='mt-4' />
        <SocialLinks tw='justify-start gap-x-8 gap-y-4 md:gap-8' />
      </MenuContent>
    </>
  );
};
